export const dashboardVendorCommission = {
    id: {
        id: 'id',
        hidden: true,
        label: 'Vendor Id'
    },
    fName: {
        id: 'fName',
        label: "Name"
    },
    mobile: {
        id: 'mobile',
        label: 'Mobile No.'
    },
    commissionValue: {
        id: 'commissionValue',
        label: 'Commission Value (in ₹)'
    },
    retailStoreName: {
        id: 'retailStoreName',
        label: 'Retail Store Name'
    },
    createdAt: {
        id: 'createdAt',
        label: 'Date',
        type: 'date'
    },
}

export const dashboardSalesReport = {
    id: {
        id: 'id',
        label: 'Vendor Id'
    },
    fName: {
        id: 'fName',
        label: "Name"
    },
    district: {
        id: 'district',
        label: "Location"
    },
    planType: {
        id: 'planType',
        label: "Plan Type"
    },
    planValue: {
        id: 'planValue',
        label: "Plan Value"
    },
    transactionId: {
        id: 'transactionId',
        label: "Transaction Id"
    },
    createdAt: {
        id: 'createdAt',
        label: 'Date',
        type: 'date'
    },
}

export const dashboardVendorList = {
    id: {
        id: 'id',
        label: 'Vendor Id'
    },
    fName: {
        id: 'fName',
        label: "Name"
    },
    district: {
        id: 'district',
        label: "Location"
    },
    retailStoreName: {
        id: 'retailStoreName',
        label: 'Retail Store Name'
    },
    grossSale: {
        id: 'grossSale',
        label: 'Gross Sale (with commission)'
    },
    createdAt: {
        id: 'createdAt',
        label: 'Created At',
        type: 'date'
    },
    mobile: {
        id: 'mobile',
        label: 'Phone Number'
    }
}

export const dashboardSubscriberListHeadCells = {
    id: {
        id: 'id',
        label: 'Customer Id',
        hidden: true
    },
    fName: {
        id: 'fName',
        label: "Name"
    },
    mobile: {
        id: 'mobile',
        label: "Mobile"
    },
    planType: {
        id: 'planType',
        label: "Plan Type"
    },
    createdAt: {
        id: 'createdAt',
        label: "Recharge Date",
        type: 'date'
    },
    vendorName: {
        id: 'vendorName',
        label: "Vendor Name"
    },
    vendorId: {
        id: 'vendorId',
        label: "Vendor Id"
    },
    district: {
        id: 'district',
        label: "Location"
    }
}

export const dashboardPlanHeadCells = {
    id: {
        id: 'id',
        hidden: true,
        showInView: true
    },
    name: {
        id: 'name',
        label: "Offer Name",
        showInView: true
    },
    revenue: {
        id: 'revenue',
        label: "Revenue (₹)",
        showInView: true
    },
    totalCount: {
        id: 'totalCount',
        label: "Total Sold Count",
        showInView: true
    },
}


export const dashboardOfferCodeCountByOfferIdentifierHeadCells = {
    id: {
        id: 'id',
        hidden: true,
        showInView: true
    },
    offerIdentifier: {
        id: 'offerIdentifier',
        label: "Offer Identifier",
        showInView: true
    },
    totalClaimCount: {
        id: 'totalClaimCount',
        label: "Total offers claimed",
        showInView: true
    },
    totalUnClaimCount: {
        id: 'totalUnClaimCount',
        label: "Total offers not claimed",
        showInView: true
    },
}